import { useState } from 'react';

import { CheckBoxCellProps } from './type';
import CheckBox from '../../../CheckBox';
import { CheckBoxCellStyled } from './styled';

const CheckBoxCell = ({ ...props }: CheckBoxCellProps) => {
  const { onChange, label, disabled, containerStyle, checkBoxStyle, initiallyChecked, ...rest } =
    props;
  const [checked, setChecked] = useState<boolean>(initiallyChecked);

  const handleChange = () => {
    const newCheckedStatus = !checked;
    setChecked(newCheckedStatus);
    onChange(newCheckedStatus);
  };

  return (
    <CheckBoxCellStyled style={containerStyle} {...rest}>
      <CheckBox
        disabled={disabled}
        label={label}
        onChange={handleChange}
        checked={checked}
        labelContainerStyle={{ minWidth: 'inherit' }}
        style={checkBoxStyle}
      />
    </CheckBoxCellStyled>
  );
};

CheckBoxCell.defaultProps = {
  checkBoxStyle: {},
  containerStyle: {},
  disabled: false,
  initiallyChecked: false,
  label: '',
  onChange: () => {},
};

export default CheckBoxCell;
